export default [
  /**
   * 贷前协议
   * 目前用于信审流程
   */
  {
    path: '/agreement/preloan',
    meta: {
      title: '贷前协议',
      background: '#fff',
    },
    component: () => import('@/views/agreement/preloan.vue'),
  },
  /**
   * 协议列表
   * 目前仅用于宜享花APP
   */
  {
    path: '/agreement/list/app',
    meta: {
      excludeLogin: true,
      background: '#fff',
      title: '注册隐私协议',
    },
    component: () => import('@/views/agreement/list-for-app.vue'),
  },
];
